module.exports = __webpack_public_path__ + "static/img/img_10.25ba1118.png";